(function() {
    "use strict";
    const locale = Shopify.locale;

    function isEmptyOrNull(arr) {
        return !(arr != null && arr.filter((item => item != null)));
    }

    function isValidBusinessDay(date, businessDays, holidays) {
        const dayOfWeek = date.getDay() === 0 ? 7 : date.getDay();
        const isBusinessDay = businessDays.indexOf(dayOfWeek) !== -1;
        const isHoliday = holidays.indexOf(formatDate(date)) !== -1;
        return isBusinessDay && !isHoliday;
    }

    function formatDate(date) {
        if (!date) return "";
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedDay = day < 10 ? "0" + String(day) : String(day);
        const formattedMonth = month < 10 ? "0" + String(month) : String(month);
        const formattedYear = String(year);
        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    }

    function getNextValidDate(startDate, businessDays, holidays, daysToAdd) {
        let currentDate = startDate;
        let validDaysCount = 0;
        let totalDaysChecked = 0;

        if (daysToAdd === 0 && isValidBusinessDay(currentDate, businessDays, holidays)) {
            return currentDate;
        }

        if (daysToAdd === 0) {
            daysToAdd = 1;
        }

        do {
            currentDate = new Date(startDate.setDate(startDate.getDate() + 1));
            if (isValidBusinessDay(currentDate, businessDays, holidays)) {
                validDaysCount++;
            } else {
                totalDaysChecked++;
            }
        } while (validDaysCount < daysToAdd && totalDaysChecked < 100);

        return currentDate;
    }

    function initShippingInfo() {
        const shippingInfoElement = document.getElementById("shipping-info");
        const shippingInfoTextElement = document.querySelectorAll(".shipping-info-text-new");
        const shippingInfoProps = getShippingInfoProps(shippingInfoElement);

        if (!shippingInfoProps) return;

        const { config, productTags } = shippingInfoProps;
        var { holidays, businessDays, hourLimit, translatedDateTemplate, textByTagItems } = config;

        // Add minuteLimit variable
        let minuteLimit = 0;

        // Get current date
        const today = new Date();
        
        // Check if it's December 16th
        const isDecember16 = today.getMonth() === 11 && today.getDate() === 16;
        
        // Check if it's December 24th or 31st
        const isDecember24or31 = today.getMonth() === 11 && (today.getDate() === 24 || today.getDate() === 31);
        
        // Check if any product has ENCORTE tag
        const hasEncorteTag = productTags.includes('ENCORTE');
        const hasEngrabadoTag = productTags.includes('ENGRABADO');
        const hasEngrabadoAceroTag = productTags.includes('ENGRABADOACERO');
        const hasHumanTag = productTags.includes('ENHUMAN');
        const hasEngrabado48Tag = productTags.includes('ENGRABADO48');

        // Modify hourLimit for ENGRABADO, ENCORTE and ENGRABADOACERO
        if (hasEngrabadoTag || hasEncorteTag || hasEngrabadoAceroTag) {
            hourLimit = 22;
            minuteLimit = 0;
        }
        // Set hourLimit for December 24th and 31st
        else if (isDecember24or31) {
            hourLimit = 13;
            minuteLimit = 30;
        }
        // Existing Monday condition
        else if (today.getDay() === 5) {
            hourLimit = 13;
            minuteLimit = 30;
        }
        // ENHUMAN Tag
        else if (hasHumanTag) {
            hourLimit = 12;
            minuteLimit = 0;
        }
        //ENGRABADO48 Tag
        else if(hasEngrabado48Tag){
            hourLimit = 23;
            minuteLimit = 59;
        }

        const matchingTagItem = textByTagItems.find((item => {
            let { tag } = item;
            return productTags.includes(tag);
        }));

        if (matchingTagItem == null || !matchingTagItem.text) {
            return shippingInfoElement == null ? undefined : shippingInfoElement.remove();
        }

        
        

        const shippingInfoText = generateShippingInfoText({
            shippingInfoText: matchingTagItem?.text,
            holidays: holidays,
            businessDays: businessDays,
            hourLimit: hourLimit,
            minuteLimit: minuteLimit, // Add minuteLimit to the options
            translatedDateTemplate: translatedDateTemplate
        });

        if (shippingInfoTextElement.length) {
            shippingInfoTextElement.forEach(item=>{
                item.innerText = shippingInfoText;
            })
        }
    }

    function getShippingInfoProps(element) {
        return element && parseJSON(element.getAttribute("data-props")) || null;
    }

    function parseJSON() {
        let jsonString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        if (jsonString) {
            try {
                return JSON.parse(jsonString);
            } catch (error) {
                if (console.error) {
                    console.error("Error while parsing JSON:", jsonString);
                } else {
                    console.log("Error while parsing JSON:", jsonString);
                }
            }
        }
    }

    function generateShippingInfoText(options) {
        let { shippingInfoText, holidays, businessDays, hourLimit, minuteLimit, translatedDateTemplate } = options;

        if (!/{{\d*}}/.test(shippingInfoText)) return shippingInfoText;

        const match = /{{(\d*)}}/.exec(shippingInfoText);
        const daysToSendString = match != null && match.length ? match[1] : "";
        const daysToSend = parseInt(daysToSendString, 10) || 1;

        const shippingDate = calculateShippingDate({
            startDate: new Date((new Date()).toLocaleString("en-US", { timeZone: "Europe/Madrid" })),
            holidays: holidays,
            sendingBusinessDays: businessDays,
            hourLimit: hourLimit,
            minuteLimit: minuteLimit, // Add minuteLimit to the options
            daysToSend: daysToSend,
            language: locale
        });

        if (shippingDate == null || !shippingDate.day || !shippingDate.month) return "";

        const formattedDate = formatTemplateString(translatedDateTemplate, shippingDate);
        return shippingInfoText.replace(/{{\d*}}/, formattedDate);
    }

    function calculateShippingDate(options) {
        let { startDate, holidays = [], sendingBusinessDays, deliveryBusinessDays = sendingBusinessDays, hourLimit = null, minuteLimit = 0, daysToSend = null, language } = options;

        if (!sendingBusinessDays || isEmptyOrNull(sendingBusinessDays) || !deliveryBusinessDays || isEmptyOrNull(deliveryBusinessDays) || hourLimit === null || daysToSend === null) return;

        const adjustedStartDate = adjustStartDate(startDate, sendingBusinessDays, holidays, hourLimit, minuteLimit);
        const shippingDate = getNextValidDate(adjustedStartDate, deliveryBusinessDays, holidays, daysToSend > 0 ? daysToSend - 1 : 0);

        const monthName = new Intl.DateTimeFormat(language, { month: "long" }).format(shippingDate);
        return {
            day: new Intl.DateTimeFormat(language, { day: "2-digit" }).format(shippingDate),
            month: monthName
        };
    }

    function adjustStartDate(date, businessDays, holidays, hourLimit, minuteLimit) {
        const adjustedDate = new Date(date);
        if (adjustedDate.getHours() > hourLimit || (adjustedDate.getHours() === hourLimit && adjustedDate.getMinutes() >= minuteLimit)) {
            adjustedDate.setDate(adjustedDate.getDate() + 1);
            adjustedDate.setHours(0, 0, 0, 0);
        }
        return getNextValidDate(adjustedDate, businessDays, holidays, 0);
    }

    function formatTemplateString(template, values) {
        let result = template;
        Object.keys(values).forEach((key => {
            result = result.replace(`{{ ${key} }}`, values[key]);
        }));
        return result;
    }

    initShippingInfo();
})();